import { SelectAssigneesModalCtrl } from "./controllers/select-assignees";
import { AssigneeService } from "./services";
import { AssigneeActions } from "./redux/assignee-actions";
import { AssigneeSelector } from "./directives/assignee-selector";
import { InviteUser } from "./directives/invite-user";
import { AssigneeSelectorModal } from "./assignee-selector-modal";
import { OwnerSelectorCtrl } from "./controllers/owner-selector";
import { SelectAssigneeModalCtrl } from "./controllers/select-assignee-modal-ctrl";
import { SelectMultipleAssigneesCtrl } from "./controllers/select-multiple-assignees-ctrl";
import { AssigneeDetailsPopoverComponent } from "./components/assignee-details-popover/assignee-details-popover.component";

const app = angular.module("assignees", []);

app.component("assigneeDetailsPopover", AssigneeDetailsPopoverComponent);

app.controller("OwnerSelectorCtrl", OwnerSelectorCtrl);
app.controller("SelectAssigneeModalCtrl", SelectAssigneeModalCtrl);
app.controller("SelectMultipleAssigneesCtrl", SelectMultipleAssigneesCtrl);
app.controller("SelectAssigneesModalCtrl", SelectAssigneesModalCtrl);

app.service("AssigneeService", AssigneeService);
app.service("AssigneeActions", AssigneeActions);
app.service("AssigneeSelectorModal", AssigneeSelectorModal);

app.directive("assigneeSelector", AssigneeSelector.factory());
app.directive("inviteUser", InviteUser.factory());

export default app.name;
